module.exports = __webpack_public_path__ + "img/kousuan.016be51f.png";